import React, {  Fragment, useEffect, useState } from 'react';

import { StyleSheet, css } from 'aphrodite';
import { Helper } from '../common/helpers/Helper';
import { SelectBox, SliderComponent, CheckBoxComponent, PlacesTextBox, SelectBoxMulti } from '../components/FormInputs';
import { filterFormField } from '../common/data/data'
import { AppButton } from '../common/components/AppButton';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Toast } from '../components/Toast';
import { useHistory, useLocation } from 'react-router-dom'
import { Controller } from '../common/Controller';
import { LoginDialog } from '../components/LoginDialog';
import { AppConfig } from '../AppConfig';
import { Chip, CircularProgress, Tooltip } from '@material-ui/core';
import { AppHelper } from '../helpers/AppHelper';
import { campaignAdFrequencyField, downloadVenueFieldDef } from '../data/data';
import { DynamicFormDialog } from '../common/components/DynamicFormDialog';

export function Players(props) {

  const history = useHistory()
  const location = useLocation()

  const isEdit = props.edit;
  const propsData = props.data

  const defaultLocation = {
    lat: AppConfig.DEFAULT_MAP_LOCATION.LAT,
    lng: AppConfig.DEFAULT_MAP_LOCATION.LNG,
    name: AppConfig.DEFAULT_MAP_LOCATION.NAME
  }

  const isCheckedIdArrayHelper = (items) => {
    return items.map(item => item.id)
  }

  // URL params read
  const search = useLocation().search
  const locationVar = {}
  const searchParams = new URLSearchParams(search)
  const [loginParams, setloginParams] = useState({
    ac: searchParams.get('ac'),
    utm_source: searchParams.get('utm_source'), // eslint-disable-line camelcase
    utm_medium: searchParams.get('utm_medium'), // eslint-disable-line camelcase
    utm_campaign: searchParams.get('utm_campaign'), // eslint-disable-line camelcase
    referer: searchParams.get('ac'),
  });
  const locationName = searchParams.get('placename')
  locationVar.lat = Number(searchParams.get('lat'))
  locationVar.lng = Number(searchParams.get('lng'))
  const radiusFromUrl = searchParams.get('radius')
  const initialLocation = locationVar.lat !== 0 ? locationVar : defaultLocation

  //pre-fill data from edit dialog / url params / default
  const [selectedLocation, setSelectedLocation] = React.useState(initialLocation);
  const [placeName, setPlaceName] = React.useState((isEdit && propsData.locationName) ? propsData.locationName || '' : (locationName ? locationName : defaultLocation.name));
  const [radius, setRadius] = React.useState((isEdit && propsData.radius) ? propsData.radius : (radiusFromUrl ? radiusFromUrl : 20));
  const [storeType, setStoreType] = React.useState((isEdit && propsData.selectedStores) ? propsData.selectedStores || [] : []);
  const [isCheckAll, setIsCheckAll] = useState(true);
  const [isCheck, setIsCheck] = useState((isEdit && propsData.screens) ? isCheckedIdArrayHelper(propsData.screens || []) : []);
  const [adFrequency, setAdFrequency] = React.useState((isEdit && propsData.adsFrequency) ? {
    key: `${propsData.adsFrequency}`,
    value: `${propsData.adsFrequency}`,
    frequency: propsData.adsFrequency
  } : {
    key: '1',
    value: '1',
    frequency: 1
  });
  const [storeTypeFullList, setStoreTypeFullList] = useState([])
  const [inProcess, setInProcess] = useState(false)
  const [unitPrice, setUnitPrice] = useState(0)
  const [screensItem, setScreensItem] = React.useState()
  const [total, setTotal] = React.useState(0)
  const [count, setCount] = React.useState(0)
  const [showLoginDailog, setShowLoginDailog] = useState(false)
  const [showOrgSignup, setshowOrgSignup] = useState(false)
  const [allLoaded, setAllLoaded] = useState(false)
  const [currentUser, setCurrentUser] = useState(Controller.get().roleHelper().getAppUser())
  // error handling
  const [deviceSearchErrMsg, setDeviceSearchErrMsg] = React.useState('');
  const [openErrorToast, setOpenErrorToast] = useState(false)
  const [showConfirmationDialog,setShowConfirmationDialog] = useState(false)
  const [venueExplorer, setVenueExplorer] = useState(props.venueExplorer || false)
  const [radiusDisabled,setRadiusDisabled] = useState(false)
  const frequencyField = campaignAdFrequencyField
  const [markers, setMarker] = useState({})

  const showError = (errMsg) => {
    setDeviceSearchErrMsg(errMsg)
    setOpenErrorToast(true)
  }

  const iconImg = require('../assets/images/map-marker.svg')
  const iconImgSelected = require('../assets/images/map-marker-selected.svg')
  useEffect(() => {
    Promise.all([fetchDevices(), fetchStoreType()])
      .then((data) => {
        setAllLoaded(true)
      })
      .catch(err => {
        showError(Helper.getErrorMsg(err))
      })
  }, [])

  useEffect(() => {
    fetchDevices()
  }, [storeType, selectedLocation])

  //loading the map with markers
  const loadMap = (data) => {
    if (data) {
      for (const i of data.items) {
        // changing data for map input lon --> lng
        if (i.location) {
          i.location.lng = i.location.lon
          // TODO: this will change the backend response also since it is a reference object
          delete (i.location.lon);
        }
      }
    }
    const locationItem = selectedLocation ? selectedLocation : initialLocation
    const map = new window.google.maps.Map(document.getElementById('map'), {
      zoom: 10,
      center: locationItem,
    })
    const tempMarker = {}
    data && data.items.forEach(function (item, i) {
      const marker = new window.google.maps.Marker({
        position: item.location,
        map,
        optimized: false,
        icon: iconImg
      });
      tempMarker[item.id] = marker
    });
    setMarker(tempMarker)
  }

  // fetching the Store Types
  async function fetchStoreType() {
    try {
      const queryParams = {
        limit: 1500
      }
      const response = await ApiHelper.callAwait({
        method: 'GET',
        endPoint: ApiHelper.makeUrlPath(['miscs', 'devicesearch'], queryParams),
        authWithKey: true
      })
      const storeTypes = response.stats.facets
      const storeTypeList = []
      for (const item of storeTypes) {
        if (item.key === 'openoohcategory') {
          for (const j of item.values) {
            storeTypeList.push({ key: j.value, value: j.value })
          }
        }
      }
      setStoreTypeFullList(storeTypeList)
      setUnitPrice(response.up || 0)
    }
    catch (err) {
      showError(Helper.getErrorMsg(err))
    }
  }
  const clearLocation = () =>{
    setPlaceName('')
  }
  useEffect(() => {
    if (currentUser && venueExplorer && placeName === '') {
      setRadiusDisabled(true)
      fetchDevices()
    }
  }, [placeName])

  //Left side filter forms
  const getFilterContainer = () => {
    return (
      <div className={css(Styles.leftContainer)}>
        <div className={css(Styles.leftTitileContainer)}>
          {/* <p className={css(Styles.title)}>{Helper.getString('venuefilters')}</p> */}
          <img
            width={'175'}
            height={'64'}
            className={css(Styles.logoImage)}
            src={require('../assets/images/logo-colored.svg')}/>
        </div>

        <PlacesTextBox
          item={filterFormField.location}
          value={placeName}
          handlePlaceTextBox={handlePlaceTextBox}
          handleTextBox={handleTextBox}
          onClearLocation={(currentUser && venueExplorer) ? clearLocation : null } />

        <SliderComponent
          item={filterFormField.radius}
          value={radius}
          handleSlider={handleSlider}
          handleSliderCommited={handleSliderCommited}
          disabled={radiusDisabled}/>

        <SelectBoxMulti
          item={filterFormField.storeType}
          optionData={storeTypeFullList && storeTypeFullList}
          value={storeType}
          handleSelectBox={handleSelectBox} />
      </div>
    )
  }

  const getErrorToast = () => {
    return (
      <Toast open={openErrorToast}
        severity='error'
        message={deviceSearchErrMsg}
        handleClose={handleErrorToastClose}
      />
    )
  }

  const handleErrorToastClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenErrorToast(false)
  };

  const locationsDownloadContainer = () => {
    return( props.downloadButton(isCheck, screensItem, inProcess))
  }

  const campaignCreateContainer = () => {
    return (
      <div className={css(Styles.subscriptionContainer)}>
        {!venueExplorer && // Show frequescy only out side
          <SelectBox
            item={frequencyField}
            optionData={frequencyField.items}
            value={adFrequency}
            handleSelectBox={handleSelectBox}
            containerStyle={Styles.textBoxContainer} />
        }

        <div className={css(Styles.priceAndButtonContainer)}>
          {AppHelper.renderCampaignCost(total, count, { org: props.org })}
          {!isEdit && !venueExplorer &&
            <AppButton
              buttonStyle={Styles.buttonStyle}
              buttonTextStyle={Styles.buttonTextStyle}
              inProcess={inProcess}
              onClick={() => isEdit ? editCampaign() : createCampaign()}
              buttonText={isEdit ? Helper.getString('campaignBtnUpdate') : Helper.getString('campaignBtnCreate')}
            />
          }
          {currentUser && venueExplorer &&
            <Fragment>
              <AppButton
                disabled={!screensItem  || screensItem.length === 0}
                buttonStyle={(!screensItem  || screensItem.length === 0) ? Styles.buttonStyleDisabled : Styles.buttonStyle }
                buttonTextStyle={Styles.buttonTextStyle}
                inProcess={inProcess}
                onClick={()=> { setShowConfirmationDialog(true) }}
                buttonText={Helper.getString('download')}
              />
              {renderConfirmationDialog()}
            </Fragment>
          }
        </div>
      </div>
    )
  }
  const renderConfirmationDialog = () => {
    if(!showConfirmationDialog) return ''
    return (
      <DynamicFormDialog
        customSubmit={customSubmitHandle}
        formDefinition={downloadVenueFieldDef.fieldDef}
        isOpen={showConfirmationDialog}
        onClosed={() => setShowConfirmationDialog(false)}
      >
      </DynamicFormDialog>
    )
  }
  const customSubmitHandle = async (data) =>{
    const {formData, caller} = data
    const payload = {
      groupId:'PRODUCT',
      action:formData.action,
      ids:screensItem.map(x=>x.id),
      format: 'INTERNAL',
      query:{
        categories: storeType
      }
    }
    if (placeName) { // If place is selected then only send to download
      payload.query = {...payload.query,
        radius: radius,
        location: {
          ...selectedLocation,
          name: placeName,
        }
      }
    }

    // Job API Call
    ApiHelper.call({
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath(['jobs']),
      jsonBody: payload,
    }, (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      }
      setShowConfirmationDialog(false)
      Controller.get().pushRoute('/admin/jobs')
    })
  }
  const getVenueContainer = () => {
    const selectAll = {
      key: 'selectall',
      id: 'selectall',
      title: 'Select all',
    }
    return (
      <div className={css(Styles.screensContainer)}>
        <div className={css(Styles.rawContainer)}>
          <p className={css(Styles.title)}>{Helper.getString('venues')}</p>
          {screensItem &&
            <p className={css(Styles.subLabel)}>{screensItem.length} screen(s)</p>
          }
        </div>

        <div className={screensItem && screensItem.length !== 0 ? css(Styles.screensResultContainer)
          : css(Styles.screensResultContainer, Styles.emptyContainer)}>
          {/* {screensItem && screensItem.length !== 0 &&
            <CheckBoxComponent
              item={selectAll}
              name={'screens'}
              handleCheckBoxClick={handleSelectAll}
              isChecked={isCheckAll} />
          } */}

          {screensItem && screensItem.map((item, index) => {
            return (
              <CheckBoxComponent
                venueExplorer={venueExplorer}
                item={item}
                name={'screens'}
                key={index}
                handleCheckBoxClick={handleCheckBox}
                isChecked={isCheck.includes(item.id)} />
            )
          })}

          {screensItem && screensItem.length === 0 &&
            <p className={css(Styles.emptyText)}>{Helper.getString('emptyScreens')}</p>
          }
        </div>
      </div>
    )
  }

  //map and places
  const getMapContainer = () => {
    return (
      <div id={'map'} className={css(Styles.mapContainer)}>
      </div>
    )
  }

  const getTotal = () => {
    if (isCheck !== '' || adFrequency !== '') {
      setInProcess(true)

      const adFrequencyValue = adFrequency ? adFrequency.frequency : 0
      const total = isCheck ? unitPrice * isCheck.length * adFrequencyValue : 0
      setTotal(total)
      setCount(isCheck.length)
      setInProcess(false)
    }
  }

  const handleSelectAll = (key, e) => {
    if (isCheckAll) {
      setIsCheck([]);
    } else {
      setIsCheck(screensItem.map(li => li.id));
    }
    setIsCheckAll(!isCheckAll);
  }

  useEffect(() => {
    if ((isCheck && screensItem) && ((isCheck.length) === (screensItem.length))) {
      // setIsCheckAll(true);
    } else {
      setIsCheckAll(false)
    }
    getTotal()
  }, [isCheck, adFrequency, unitPrice])


  const handleCheckBox = (key, e) => {
    if (!e.target.checked) {
      setIsCheck(isCheck.filter(item => item !== key));
      if (markers[key]) {
        markers[key].setIcon({
          url: iconImg
        });
      }
    } else {
      setIsCheck([...isCheck, key])
      if (markers[key]) {
        markers[key].setIcon({
          url: iconImgSelected
        });
      }
    }
  }

  const handleTextBox = (key, e) => {
    setPlaceName(e.target.value)
    if (radiusDisabled) {
      setRadiusDisabled(false)
    }
  }

  const handlePlaceTextBox = (key, value) => {
    setPlaceName(value.formatted_address || '')
    if (radiusDisabled) {
      setRadiusDisabled(false)
    }
    if (value.geometry && value.geometry.location) {
      setSelectedLocation({
        lat: value.geometry.location.lat(),
        lng: value.geometry.location.lng(),
      })
    }
  }

  const handleSelectBox = (e, value, key) => {
    if (key === 'storeType') {
      setStoreType(value)
    }
    if (key === 'adFrequency') {
      setAdFrequency(value)
    }
  }

  const handleSlider = (e, value) => {
    if (value === 0) return
    setRadius(value)
  }

  const handleSliderCommited = () => {
    fetchDevices()
  }

  //Fetching the devices
  async function fetchDevices() {

    const facetsValue = storeType !== null ? { key: 'openoohcategory', values: storeType } : ''
    setInProcess(true)

    try {
      // const queryParams = {
      //   facets: facetsValue ? JSON.stringify([facetsValue]) : JSON.stringify([]),
      //   locationFilter: JSON.stringify({
      //     geo_distance: { // eslint-disable-line camelcase
      //       distance: radius + 'miles',
      //       location: {
      //         lat: selectedLocation ? selectedLocation.lat : initialLocation.lat,
      //         lon: selectedLocation ? selectedLocation.lng : initialLocation.lng
      //       }
      //     }
      //   }),
      //   limit: 1500
      // }
      const queryParams = {
        facets: facetsValue ? JSON.stringify([facetsValue]) : JSON.stringify([]),
        limit: 1500
      }
      if (placeName) {
        queryParams.locationFilter = JSON.stringify({
          geo_distance: { // eslint-disable-line camelcase
            distance: radius + 'miles',
            location: {
              lat: selectedLocation ? selectedLocation.lat : initialLocation.lat,
              lon: selectedLocation ? selectedLocation.lng : initialLocation.lng
            }
          }
        })
      }

      const response = await ApiHelper.callAwait({
        method: 'GET',
        endPoint: ApiHelper.makeUrlPath(['miscs', 'devicesearch'], queryParams),
        authWithKey: true
      })

      //Removing queryparams after api call
      history.replace({
        pathname: location.pathname,
        search: '',
      })

      // const items = isCheck && isCheck.length > 0 ? isCheck : response.items.map(li => li.id)
      // const responseItem = response.items.map(li => li.id)
      // const updateItems = items === responseItem ? isCheck : response.items.map(li => li.id)
      const updateItems = response.items.map(li => li.id)
      loadMap(response)
      const filteredItems = props.mode === 'LOCATIONS'
        ? response.items.filter(item => item.onlineStatus === 'ONLINE')
        : response.items;
      setScreensItem(filteredItems)
      // !isEdit && setIsCheck(updateItems)
      setIsCheck([]);
      setInProcess(false)
    }
    catch (e) {
      const errorMessage = Helper.getErrorMsg(e);
      showError(errorMessage)
      setInProcess(false)
    }
  }

  const createCampaign = async () => {
    if (!Controller.get().loginMgr().getCurrentUser() || !Controller.get().userMgr().getAppUser().orgs || Controller.get().userMgr().getAppUser().orgs.length === 0) {
      if (Controller.get().loginMgr().getCurrentUser()) {
        setshowOrgSignup(true)
      }
      setShowLoginDailog(true)
      return
    }

    if (!isCheck || isCheck.length === 0) {
      showError(Helper.getString('selectScreens'))
      return
    }
    if (!adFrequency || !adFrequency.key) {
      showError(Helper.getString('selectAdfrequency'))
      return
    }
    if (!placeName || !selectedLocation) {
      showError(Helper.getString('selectLocation'))
      return
    }

    const orgId = Controller.get().userMgr().getOrgId()
    const body = {
      groupId: orgId,
      iType: 'ADVERTISER' // Campaign type is self-serve advertiser
    }
    body.screens = isCheck
    body.frequency = Number(adFrequency.key)
    body.query = {
      location: {
        lat: selectedLocation.lat,
        lng: selectedLocation.lng,
        name: placeName,
      },
      radius: radius,
      categories: storeType
    }

    try {
      setInProcess(true)
      const response = await ApiHelper.callAwait({
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['campaigns']),
        jsonBody: body
      })
      setInProcess(false)
      const pathname = '/admin/advertisers/' + orgId + '/campaigns/' + response.id
      Controller.get().pushRoute(pathname);
    }
    catch (e) {
      const errorMessage = Helper.getErrorMsg(e);
      setInProcess(false)
      showError(errorMessage)
    }
  }

  const editCampaign = () => {
    props.closeModal && props.closeModal()
    //TODO: edit workflow not complete since not clear on what all can be edited
    // This will accessed only from logged in view
  }

  const onSuccessLogin = () => {
    setShowLoginDailog(false)
    createCampaign()
  }

  return (
    <Fragment>
      {!allLoaded &&
        <div className={css(Styles.pageBg)} >
          <div className={css(Styles.progressContainer)}>
            <CircularProgress size={48} className={css(Styles.progress)} />
          </div>
        </div>
      }

      <div className={css(allLoaded ? Styles.container : Styles.containerHidden)}>
        {getMapContainer()}
        {getVenueContainer()}
        <div className={css(Styles.filterContainer)}>
          {getFilterContainer()}
          {props.mode === 'LOCATIONS' ? locationsDownloadContainer() : campaignCreateContainer()}
        </div>
        {getErrorToast()}
        <LoginDialog
          openDialog={showLoginDailog}
          jsonBody={{}}
          showOrgSignup={showOrgSignup}
          loginParams={loginParams}
          onClose={() => setShowLoginDailog(false)}
          onSuccessLogin={onSuccessLogin}
        />
      </div>
    </Fragment>
  );
}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    padding: 40,
    gap: 20,
    '@media (max-width: 1024px)': {
      flexDirection: 'column-reverse',
    },
    boxSizing: 'border-box',
    '@media (max-width: 767px)': {
      padding: 20,
      marginBottom: 350
    },
    backgroundColor: '#fff'
  },
  containerHidden: {
    display: 'none'
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    // width: 325,
    // paddingTop: 40,
    flex: 1,
    '@media (max-width: 1024px)': {
      width: 'unset'
    }
  },
  leftTitileContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20
  },
  title: {
    fontSize: 28,
    fontWeight: 600,
    color: '#1B1B1B',
    margin: 0
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // marginLeft: 20,
    '@media (max-width: 1024px)': {
      marginLeft: 'unset',
    }
  },
  mapContainer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    borderRadius: 40,
    backgroundColor: '#f5f5f5',
    '@media (max-width: 1024px)': {
      borderRadius: 20,
      minHeight: 600
    }
  },
  rightBottomCountainer: {
    display: 'flex',
    flexDirection: 'row',
    // marginTop: 20,
    flex: 1,
    justifyContent: 'space-between',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      justifyContent: 'unset',
      marginBottom: 260
    }
  },
  subscriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // flex: .450,
    // border: '1px solid #DDDDDD',
    // borderRadius: 40,
    // padding: 24,
    // maxHeight: 237,
    '@media (max-width: 767px)': {
      maxHeight: 'unset',
    },
    '@media (max-width: 1024px)': {
      padding: 20,
      position: 'fixed',
      backgroundColor: '#ffffff',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      bottom: 0,
      left: 0,
      right: 0
    }
  },
  textBoxContainer: {
    marginTop: 0,
    marginBottom: 20,
    flex: 1
  },
  rawContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 19
  },
  priceAndButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: 10,
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      justifyContent: 'unset',
      alignItems: 'unset',
    }
  },
  subLabel: {
    fontSize: 14,
    fontWeight: 400,
    color: '#747474',
    margin: 0,
    marginRight: 8
  },
  buttonStyle: {
    minHeight: 54,
    minWidth: 180,
    padding: 16,
    backgroundColor: AppConfig.TINT_COLOUR,
    '@media (max-width: 767px)': {
      marginTop: 10,
      padding: 8
    }
  },
  buttonStyleDisabled:{
    minHeight: 54,
    minWidth: 180,
    padding: 16,
    backgroundColor: '#747474',
    '@media (max-width: 767px)': {
      marginTop: 10,
      padding: 8
    }
  },
  buttonTextStyle: {
    fontSize: 16,
    fontWeight: 700,
    margin: 0,
    color: '#FFFFFF',
    '@media (max-width: 767px)': {
      fontSize: 16,
    }
  },
  screensContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    border: '1px solid #DDDDDD',
    borderRadius: 40,
    padding: 24,
    maxHeight: '92vh',
    boxSizing: 'border-box',
    // marginRight: 20,
    '@media (max-width: 1024px)': {
      marginRight: 'unset',
      marginBottom: 20,
      maxHeight: 'unset'
    }
  },
  screensResultContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  emptyContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  emptyText: {
    fontSize: 20,
    color: '#1B1B1B'
  },
  pageBg: {
    background: `url(${require('../assets/images/map-bg-720.jpg')})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    width: '100%',
    minHeight: '100%'
  },
  progressContainer: {
    backgroundColor: '#000000CC',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  progress: {
    color: '#FFFFFF'
  },
  filterContainer: {
    flex: 0.7,
    display: 'flex',
    flexDirection: 'column'
  },
  logoImage: {
    height: 64,
    width: 'auto'
  }
})


// WEBPACK FOOTER //
// ./src/screens/Players.js